import { AxiosRequestConfig } from 'axios';

export const DEFAULT_HEADER = { 'Content-Type': 'application/json; charset=utf-8' };
export const TIMEOUT_ERROR_MESSAGE = 'timeoutErrorMessage';
export const DEFAULT_API_TIMEOUT = 30000;

export enum Level {
  Warn = 'warn',
  Error = 'error',
}

export type Logger = {
  debug: (name: string, message: string) => void;
  logError: (message: string, error?: Error, stack?: string) => void;
  logWarning: (message: string) => void;
};

export type RepositoryConfig = {
  logger?: Logger; // allow you to inject any logger that implements Logger interface
};

export type ApiRequestConfig = Pick<
  AxiosRequestConfig,
  'timeout' | 'headers' | 'cancelToken' | 'responseType' | 'axios-retry'
>;

export type StringfyableParam = string | number | boolean | undefined | null | string[];

export type RepositoryError<T = any> = {
  data?: T;
  etag?: string;
  meta?: any;
  status?: number; // http response status as a number ex. 200, 400, 500
  type?: number; // same as status, only for retro-compatibility
  requestUrl?: string;
  message: string;
  details?: string;
};
